import { useSelector } from "react-redux";

const isFullAdmin = (user) => {
  const role = user?.roleName?.toLowerCase();
  return role === "admin" || user?.roleId == 1;
};

const useModulePermissions = (module, subModule = null) => {
  const user = useSelector((state) => state.user.userDetails);
  const permissions = useSelector((state) => state.permission?.permissions || []);

  if (isFullAdmin(user)) return new Proxy({}, { get: () => true });

  const moduleData = permissions?.find((m) => m.key === module);
  if (!moduleData) return {};

  const target = subModule
    ? moduleData?.subModules?.find((sm) => sm.key === subModule)
    : moduleData;

  if (!target) return {};

  const result = {};
  target?.actions?.forEach((a) => (result[a.key] = a.allowed === true));

  return result;
};

export default useModulePermissions;
